import { Button, Flex } from 'antd';
import React from 'react'
import { useLanguage } from 'src/providers/LanguageProvider';
import { StepBackwardOutlined, StepForwardOutlined,LeftOutlined,RightOutlined } from '@ant-design/icons';

const getDisabledState = (currentStep: number, data: any) => {
    if (currentStep === 0) {
        // Step 1: Select Product
        if (!data.selectedProductId) {
            return true; // Disable if no product selected
        }
        if (data.selectedProductId === '13') { // Assuming '13' is the ID for the product requiring employee count
            if (!data.employeeCount || data.employeeCount <= 0) {
                return true; // Disable if employee count is not set or invalid
            }
        }
    }

    if(currentStep === 1) {
        // Step 2: Select Invoice Profile
        if (!data.selectedProfile) {
            return true; // Disable if no invoice profile selected
        }
    }

    return false; // Enable by default
}

const ContinuteButton = ({ currentStep, data, onClickContinue,onClickBack }: { currentStep: number, data: any, onClickContinue: any,onClickBack:any }) => {


    const { t } = useLanguage();

    let disabled = getDisabledState(currentStep, data);
    let disabledBack = currentStep === 0;

    if(currentStep == -1)
        return null;
    return (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
            <Button icon={
                <LeftOutlined />
            } type="default" onClick={onClickBack} disabled={disabledBack}>
                {t('BACK')}
            </Button>
            
            
            {currentStep < 2 && <Button style={{marginLeft:'10px'}} iconPosition='end' icon={
                <RightOutlined />
            } type="primary" onClick={onClickContinue} disabled={disabled}>
                {t('CONTINUE')}
            </Button> }
        </div>
    )
}

export default ContinuteButton